import React from 'react'

import Paper from 'material-ui/Paper';

import { integration as ROLES_CONFIG } from '../../../../config/roles';
import GenerateNewToken from '../../../../components/integration/GenerateNewToken';


export default class GenerateToken extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.generateNewToken.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 col-md-11 col-11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                <GenerateNewToken />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/integration/GenerateToken.js